import { useTranslation } from 'react-i18next';
import { OrderDocument } from '@/components/OrderDocument';
import { Document } from '@/types';
import { useDocuments } from '../DocumentsLayout';

const DocumentsPage = () => {
  const data = useDocuments();
  const { t } = useTranslation();
  const documents = data?.currentUser?.documents || [];

  // const documents = [
  //   {
  //     url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  //     type: 'Invoice',
  //     id: '1',
  //   },
  //   {
  //     url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  //     type: 'Invoice',
  //     id: '2',
  //   },
  // ];

  return (
    <div className="py-2-0">
      <p className="font-bd mb-1-0 text-2-0">{t('orders.documents.title')}</p>
      <div className="grid grid-cols-3 gap-x-2-0">
        {documents.map((document) => (
          <OrderDocument key={document.id} document={document as Document} />
        ))}
      </div>
      {documents.length === 0 && (
        <p className="text-body1 py-4-0 font-bd text-center">
          {t('orders.documents.not_found')}
        </p>
      )}
    </div>
  );
};

export default DocumentsPage;
